export default __webpack_public_path__ + "static/media/partly-cloudy-night.f1726c4a.svg";